function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { mediaQueries } from "../../../theme";
var SNACKBAR_INDENTS = {
  view: {
    "default": '10px'
  },
  snackbar: {
    "default": 6
  }
};
var POSITIONING_DATA = {
  top: {
    top: SNACKBAR_INDENTS.view["default"],
    flexDirection: 'column'
  },
  bottom: {
    bottom: SNACKBAR_INDENTS.view["default"],
    flexDirection: 'column-reverse'
  },
  left: {
    left: SNACKBAR_INDENTS.view["default"],
    alignItems: 'flex-start'
  },
  right: {
    right: SNACKBAR_INDENTS.view["default"],
    alignItems: 'flex-end'
  },
  center: {
    left: '50%',
    transform: 'translateX(-50%)',
    alignItems: 'center'
  }
};
var fullWidthStyles = {
  left: '16px',
  right: '16px'
};
export var getToastContainerStyles = function getToastContainerStyles(_ref) {
  var anchorOrigin = _ref.anchorOrigin;
  return _objectSpread(_objectSpread(_objectSpread({
    boxSizing: 'border-box',
    display: 'flex',
    maxHeight: '100%',
    position: 'fixed',
    height: 'auto',
    width: 'auto',
    zIndex: 'toast',
    gap: 2
  }, fullWidthStyles), POSITIONING_DATA[anchorOrigin.vertical]), {}, _defineProperty({}, mediaQueries.md, _objectSpread({}, POSITIONING_DATA[anchorOrigin.horizontal])));
};